export const check = string => string && string.text && string.text.trim() !== '';
export const checkUrl = string => string && string.url && string.url.trim() !== '';
export const checkImage = image => image && image.url && image.url.length > 5 && image.url.trim() !== '';
